<template>
  <div class="myServiceWrapper">
    <!-- 服务统计 -->
    <div class="serviceStatsWrapper">
      <ServiceStats :list="serviceStatsList" :data="serviceData" :isShowTooltip="true" />
    </div>
    <!-- 服务患者 -->
    <div class="patientWrapper">
      <div class="patientHeader">
        <Header title="服务患者">
          <template #extra>
            <div class="rightExtra">
              <a-input
                class="search"
                v-model:value="keyWord"
                placeholder="搜索患者姓名/手机号"
                allowClear
                @pressEnter="onSearch"
              >
                <template #prefix>
                  <SearchOutlined class="search_icon" />
                </template>
              </a-input>
              <a-button class="search_btn" type="primary" @click="onSearch">搜索</a-button>
            </div>
          </template>
        </Header>
      </div>
      <div class="patientBody">
        <PatientTabs
          :ucDoctorId="ucDoctorId"
          :userId="userId"
          ref="patientTabsRef"
          @pushBreadcrumb="handlePushBreadcrumb"
        />
      </div>
    </div>
    <!-- 底部footer -->
    <div class="footerWrapper">
      <BottomCopy />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineProps, onMounted, defineEmits } from 'vue'
import ServiceStats from '../components/ServiceStats'
import { serviceStatsList } from '../constant'
import { getServiceSatics } from '@/api/workPlace/serviceAttribution'
import { SearchOutlined } from '@ant-design/icons-vue'
import Header from '../components/Header'
import PatientTabs from './components/PatientTabs'
import BottomCopy from '../components/BottomCopy'
const emit = defineEmits(['pushBreadcrumb'])
const props = defineProps({
  // 医生ucDoctorId
  ucDoctorId: {
    type: String,
    default: ''
  },
  userId: {
    type: String,
    default: ''
  }
})
// 服务统计数据
const serviceData = reactive({})
// 搜索患者关键字
const keyWord = ref('')
const patientTabsRef = ref()
// 获取服务统计信息
const fetchServiceSatics = async () => {
  const { ucDoctorId } = props
  const params = {
    ucDoctorId
  }
  const result = await getServiceSatics(params)
  Object.assign(serviceData, result)
}
// 初始化数据
onMounted(() => {
  // 获取服务统计信息
  fetchServiceSatics()
  // 获取服务患者列表
  patientTabsRef.value.init()
})
// 执行患者服务搜索
const onSearch = () => {
  patientTabsRef.value.onSearch({
    keyWord: keyWord.value.trim()
  })
}
// 面包屑导航新增层级
const handlePushBreadcrumb = breadcrumbStack => {
  emit('pushBreadcrumb', breadcrumbStack)
}
</script>

<style scoped lang="scss">
.myServiceWrapper {
  width: 100%;
  height: 100%;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  .serviceStatsWrapper {
    margin-bottom: 12px;
  }

  .patientWrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    .patientHeader {
      .rightExtra {
        margin-right: 24px;
        display: flex;
        align-items: center;
        .search {
          ::v-deep(.ant-input::placeholder) {
            font-size: 14px;
            color: #00000066;
          }
          .search_icon {
            color: #999;
          }
        }

        .search_btn {
          width: 80px;
          height: 30px;
          margin-left: 12px;
        }
      }
    }

    .patientBody {
      flex: 1;
      overflow: hidden;
    }
  }

  .footerWrapper {
    margin-top: 12px;
  }
}
</style>
